import { Instagram, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import { IMAGES, CONTACT } from "../../data/site";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#141110] border-t border-white/10 px-6 lg:px-10 pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 pb-16">
          <div>
            <div className="flex items-center gap-3">
              <img
                src={IMAGES.logo}
                alt="SSV logo"
                className="h-14 w-14 rounded-full object-cover ring-1 ring-white/15"
              />
              <div className="font-marathi-bold font-extrabold text-2xl text-[#F8F4EC] leading-tight">
                {CONTACT.nameMarathi}
              </div>
            </div>
            <p className="mt-3 font-marathi text-[#F59E0B]">
              {CONTACT.taglineMarathi}
            </p>
            <p className="mt-4 max-w-xs text-[#BFAFA6] leading-relaxed">
              Where quality meets convenience. Fresh, flavourful street food
              built for today’s busy world.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {CONTACT.instagram && (
                <a
                  href={CONTACT.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  data-testid="social-instagram"
                  className="h-11 w-11 grid place-items-center rounded-full border border-white/15 text-[#F8F4EC] hover:text-[#141110] hover:bg-[#F59E0B] hover:border-[#F59E0B] transition-colors duration-300"
                >
                  <Instagram size={18} />
                </a>
              )}
              {CONTACT.facebook && (
                <a
                  href={CONTACT.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  data-testid="social-facebook"
                  className="h-11 w-11 grid place-items-center rounded-full border border-white/15 text-[#F8F4EC] hover:text-[#141110] hover:bg-[#F59E0B] hover:border-[#F59E0B] transition-colors duration-300"
                >
                  <Facebook size={18} />
                </a>
              )}
            </div>
          </div>
          <div className="lg:text-right">
            <div className="text-xs tracking-[0.2em] uppercase text-[#F59E0B] mb-4">
              Hours
            </div>
            <p className="text-[#F8F4EC]">All Days</p>
            <p className="text-[#BFAFA6]">5:00 AM – 10:00 PM</p>
          </div>
        </div>

        {/* massive logotype */}
        <div className="border-t border-white/10 pt-10">
          <div className="font-display uppercase leading-[0.8] text-[#F8F4EC] text-[26vw] lg:text-[18vw] tracking-tighter select-none">
            SSV
          </div>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-[#BFAFA6]">
          <p>© {year} Shree Siddhivinayak Vada Pav. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <p className="font-serif-e italic">Made fresh in Pimpri-Chinchwad &amp; Pune.</p>
            <span className="hidden sm:inline text-white/20">|</span>
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="text-[#BFAFA6] hover:text-[#F59E0B] transition-colors"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
